import React,{useState} from 'react'
import sliderCloseIcon from '../../assets/images/slider-close-icon.svg';
import { useDispatch } from 'react-redux';
import { setChatMessage } from '../../redux/action';

export default function SendMessageModal({handleSendMessage,voicemails}) {
  const dispatch=useDispatch()
  const [newMessage,setNewMessage]=useState('')

  return (
    <div className="offcanvas offcanvas-end" tabIndex="-1" id="sendMessageCanvas"
        aria-labelledby="sendMessageCanvasLabel">
        <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="sendMessageCanvasLabel">Send New Message</h5>
            <button type="button" className="slider-close-btn" data-bs-dismiss="offcanvas"><img
                    src={sliderCloseIcon} className="img-fluid"/></button>
        </div>
        <div className="offcanvas-body">
            
            <div className="mt-2">
                <p className="slider-info-text">Search for a saved contact or enter a new 10 digit number</p>
            </div>
            <input type="text" defaultValue={voicemails.chat_phone_no}  name="phone_no"  className="form-control slider-inputs" placeholder="Phone Number"/>
            <div className="mt-5">
                <textarea className="form-control slider-inputs text-area-height" placeholder="Send Message" aria-label="With textarea" value={newMessage} onChange={(e)=>{dispatch(setChatMessage(e.target.value));setNewMessage(e.target.value)}}></textarea>
              </div>
            

            <div className="d-flex justify-content-end mt-4">
                <button className="slider-cancel-btn me-2" data-bs-dismiss="offcanvas">Cancel</button>
                <button className="slider-success-btn" data-bs-dismiss="offcanvas" onClick={()=>{setNewMessage('');handleSendMessage()}}>Send</button>
            </div>
        </div>
    </div>

  )
}
